import { Observable } from 'rxjs'
import { ACTION_STORY_SAVED } from '../appReducer'
import { setStoryData } from '~/redux/storyData'
import ansToStoryData from '~/reactapp/story/import/ansToStoryData'

export default (action$) =>
  action$
    .filter((action) => action.type === ACTION_STORY_SAVED)
    .mergeMap((action) => {
      return Observable.of(setStoryData(ansToStoryData(action.payload.story)))
    })
